import { PodcastsPageData } from "lib/types/podcasts";

export type HeroProps = Pick<PodcastsPageData, "description" | "title">;

export const Hero = ({ title, description }: HeroProps) => {
  return (
    <div className={"w-100 max-md:text-center"}>
      <h1 className="mb-4 font-recklessBold text-[32px] leading-tight md:mb-5 md:text-[40px] lg:mb-2 lg:text-[52px]">
        {title}
      </h1>
      <div
        className="w-100 leading-tight max-md:m-auto max-md:max-w-[320px]"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
